import React from 'react';
import { Settings, ChevronRight, Shield, Heart, MessageSquare } from 'lucide-react';

const ClubSettingsManagement = ({ onNavigate, permissions }) => {
    // Only for super admins or club admins
    if (!permissions.canManageClub) return null;

    return (
        <div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">⚙️ Club Settings</h3>
            <div className="grid grid-cols-2 gap-4">
                <button
                    onClick={() => onNavigate('club-settings')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-gray-50 to-slate-50 hover:from-gray-100 hover:to-slate-100 rounded-xl p-4 transition-all text-left border border-gray-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <Settings className="text-gray-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Club Settings</h3>
                        <p className="text-xs text-gray-500 truncate">Update details</p>
                    </div>
                    <ChevronRight className="text-gray-300 group-hover:text-gray-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('player-role-management')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-purple-50 to-indigo-50 hover:from-purple-100 hover:to-indigo-100 rounded-xl p-4 transition-all text-left border border-purple-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <Shield className="text-purple-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Roles</h3>
                        <p className="text-xs text-gray-500 truncate">Manage admins</p>
                    </div>
                    <ChevronRight className="text-purple-300 group-hover:text-purple-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('volunteer-tracking')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-pink-50 to-rose-50 hover:from-pink-100 hover:to-rose-100 rounded-xl p-4 transition-all text-left border border-pink-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <Heart className="text-pink-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Volunteers</h3>
                        <p className="text-xs text-gray-500 truncate">Track hours</p>
                    </div>
                    <ChevronRight className="text-pink-300 group-hover:text-pink-600 transition-colors shrink-0" size={18} />
                </button>

                <button
                    onClick={() => onNavigate('club-feedback')}
                    className="group flex items-center gap-4 bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 rounded-xl p-4 transition-all text-left border border-blue-100"
                >
                    <div className="p-2 bg-white rounded-lg shadow-sm group-hover:scale-110 transition-transform shrink-0">
                        <MessageSquare className="text-blue-600" size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="font-bold text-gray-900 truncate">Feedback</h3>
                        <p className="text-xs text-gray-500 truncate">View comments</p>
                    </div>
                    <ChevronRight className="text-blue-300 group-hover:text-blue-600 transition-colors shrink-0" size={18} />
                </button>

            </div>
        </div>
    );
};

export default ClubSettingsManagement;
